module.exports = __webpack_public_path__ + "static/Indodax-2f73bd5fbaf315cd79587f86f0c3a070.png";